import { jsx as i, jsxs as r } from "react/jsx-runtime";
import { useBreakpoint as l, NextgenImage as d, LoaderType as s } from "@nextgen-web-framework/all";
import './assets/AmwayHighlightsItem.css';const c = "#ffffff", g = "#396e75", h = "#e5fdff", m = "#546223", f = "#f0fae5", z = "#a65523", V = "#fff1e8", _ = "#7f3e3e", C = "#ffe2e2", w = "#62625a", k = "#f8f8e7", y = "#38539a", u = "#707070", p = "#c8f8d1", B = "#87c9c8", v = "#5291b1", N = "rgba(82, 145, 177, 0.1019607843)", O = "#445685", b = "#181d61", G = "rgba(24, 29, 97, 0.1019607843)", R = "#5969d6", T = "#ea999d", W = "#b6577e", x = "rgba(182, 87, 126, 0.1019607843)", A = "#7e3e80", Y = "#1e247f", P = "rgba(30, 36, 127, 0.1019607843)", S = "#da7600", j = "#107f47", I = "#d91734", E = "_html_6sgef_38", a = {
  amwayWhite: c,
  darkBlue: g,
  lightBlue: h,
  darkGreen: m,
  lightGreen: f,
  darkOrange: z,
  lightOrange: V,
  darkRed: _,
  lightRed: C,
  darkYellow: w,
  lightYellow: k,
  darkPurple: y,
  darkGrayOnWhite: u,
  dataVizColor1: p,
  dataVizColor2: B,
  dataVizColor3: v,
  dataVizColor3Background: N,
  dataVizColor4: O,
  dataVizColor5: b,
  dataVizColor5Background: G,
  dataVizColor6: R,
  dataVizColor7: T,
  dataVizColor8: W,
  dataVizColor8Background: x,
  dataVizColor9: A,
  dataVizColor10: Y,
  dataVizColor10Background: P,
  dataVizAlertOrange: S,
  dataVizSuccessGreen: j,
  dataVizWarningRed: I,
  "no-visible": "_no-visible_6sgef_34",
  html: E,
  "amway-highlights-container": "_amway-highlights-container_6sgef_72",
  "amway-highlights-item-container": "_amway-highlights-item-container_6sgef_79",
  "amway-highlights-item-wrapper": "_amway-highlights-item-wrapper_6sgef_82",
  "img-container": "_img-container_6sgef_91",
  "img-wrapper": "_img-wrapper_6sgef_91",
  "amway-highlights-item-section": "_amway-highlights-item-section_6sgef_99",
  "title-container": "_title-container_6sgef_108",
  "description-container": "_description-container_6sgef_122"
}, L = (e) => {
  const n = l(), t = e == null ? void 0 : e.images.find((o) => o == null ? void 0 : o.viewport.includes(n));
  return /* @__PURE__ */ i("div", { className: a["amway-highlights-item-container"], "data-testid": "amway-highlights-item-test-id", "data-pod-name": "commerce", children: /* @__PURE__ */ r("div", { className: a["amway-highlights-item-wrapper"], children: [
    /* @__PURE__ */ i("div", { className: a["img-container"], children: /* @__PURE__ */ i("div", { className: a["img-wrapper"], children: /* @__PURE__ */ i(
      d,
      {
        src: (t == null ? void 0 : t.image.url) ?? "",
        alt: (t == null ? void 0 : t.alt_text) ?? "",
        loaderType: s.CONTENTSTACK
      }
    ) }) }),
    /* @__PURE__ */ r("div", { className: a["amway-highlights-item-section"], children: [
      /* @__PURE__ */ i("h3", { className: a["title-container"], children: e.title }),
      /* @__PURE__ */ i("div", { className: a["description-container"], children: e.description })
    ] })
  ] }) });
};
export {
  L as A,
  a as s
};
//# sourceMappingURL=AmwayHighlightsItem-e8a3b1fa.mjs.map
